import get from 'lodash/get'
import * as React from 'react'
import Ui from 'ui'
import Icons from 'ui/Icons'
import { sanitizeImage } from 'utils/attackPrevention/images'

function BuilderMarkerEditProps({ onUpdateQuestionProps, question }) {
  const fileRef = React.useRef()

  async function handleChange() {
    if (get(fileRef, ['current', 'files', 'length'], 0) > 0) {
      // Save image file to be uploaded to the server
      const file = await sanitizeImage(fileRef.current.files[0])

      // Save read image to display on the builder
      const reader = new FileReader()
      reader.onload = (e) => {
        onUpdateQuestionProps({
          image: file,
          imageToDisplayOnBuilder: e.target.result,
        })
      }
      reader.readAsDataURL(file)
    } else {
      return onUpdateQuestionProps({
        image: null,
        imageToDisplayOnBuilder: null,
      })
    }
  }

  function onDeletePress() {
    onUpdateQuestionProps({
      image: null,
      imageToDisplayOnBuilder: null,
    })
  }

  if (question?.imageToDisplayOnBuilder) {
    return (
      <div className="space-x-2">
        <Ui.ButtonClear className="border space-x-2 h-10" onClick={() => null}>
          <Icons.Check color="text-green-400" />
          <span>File Uploaded</span>
        </Ui.ButtonClear>
        <Ui.ButtonClear
          className="border space-x-2 px-2 h-10 w-10"
          onClick={onDeletePress}
        >
          <Icons.Refresh size={5} />
        </Ui.ButtonClear>
      </div>
    )
  }

  return (
    <div className="pt-2">
      <Ui.QuestionLabel>Base image</Ui.QuestionLabel>
      <Ui.FileInput accept="image/*" onChange={handleChange} ref={fileRef} />
    </div>
  )
}

export default BuilderMarkerEditProps
